/* TCELL reveal-on-scroll: adds .is-visible to .tcell-reveal elements once they enter the viewport.
   CSS (assets/tcell.css) only animates under prefers-reduced-motion: no-preference. */
/* Count-up: animates the digits of a "2.000+" (vi) or "2,000+" (en) style value over ~1.2s, keeping the grouping separator and suffix. */
function countUp(el) {
  const raw = el.dataset.tcellCountup || "";
  const match = raw.match(/^([^\d]*)([\d.,]+)(.*)$/);
  if (!match) return;
  const [, prefix, num, suffix] = match;
  // A separator followed by groups of exactly three digits is a thousands separator: "." in Vietnamese, "," in English.
  const viGrouping = /^\d{1,3}(\.\d{3})+$/.test(num);
  const enGrouping = /^\d{1,3}(,\d{3})+$/.test(num);
  const locale = viGrouping ? "vi-VN" : "en-US";
  const target = viGrouping ? parseInt(num.replace(/\./g, ""), 10) : parseFloat(num.replace(/,/g, ""));
  if (!Number.isFinite(target)) return;
  const decimals = viGrouping ? 0 : (num.split(".")[1] || "").length;
  const useGrouping = viGrouping || enGrouping;
  const format = (n) => n.toLocaleString(locale, { minimumFractionDigits: decimals, maximumFractionDigits: decimals, useGrouping });
  const duration = 1200;
  const start = performance.now();
  const tick = (now) => {
    const t = Math.min(1, (now - start) / duration);
    const eased = 1 - Math.pow(1 - t, 3);
    el.textContent = prefix + format(target * eased) + suffix;
    if (t < 1) requestAnimationFrame(tick);
  };
  requestAnimationFrame(tick);
}

(() => {
  const els = document.querySelectorAll('.tcell-reveal');
  if (!els.length) return;
  if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    els.forEach((el) => el.classList.add('is-visible'));
    return;
  }
  const io = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      const el = entry.target;
      const delay = parseInt(getComputedStyle(el).getPropertyValue('--tcell-reveal-delay')) || 0;
      setTimeout(() => {
        el.classList.add('is-visible');
        el.querySelectorAll('[data-tcell-countup]').forEach(countUp);
      }, delay);
      io.unobserve(el);
    });
  }, { rootMargin: '0px 0px -10% 0px', threshold: 0.1 });
  els.forEach((el) => io.observe(el));
})();
